import React from 'react';
import { Image } from 'react-native';
import { AmenityProps } from 'src/common/api/response';
import { Container, RegularText, Row } from 'src/components';
import { AppColors } from 'src/themes/Colors';
import { metrics, pixelScaler } from 'src/themes/Metrics';

// export const Amenities = ({ hideTitle = false }: { hideTitle?: boolean }) => {
//   return (
//     <Container>
//       {!hideTitle && <RegularText fontWeight="bold" textLang="amenities" />}

//       <Row marginTop={metrics.medium}>
//         <AmenetyItem hideTitle={hideTitle} icon="icon-wifi" text="wifi" />
//         <AmenetyItem hideTitle={hideTitle} icon="icon-water" text="water" />
//         <AmenetyItem hideTitle={hideTitle} icon="icon-coffee" text="coffee" />
//         <AmenetyItem hideTitle={hideTitle} icon="icon-plug" text="plug" />
//         <AmenetyItem hideTitle={hideTitle} icon="icon-bed" text="sleeper" />
//       </Row>
//     </Container>
//   );
// };

export const NewAmenities = ({ amenities, hideTitle = false }: { amenities: AmenityProps[]; hideTitle?: boolean }) => {
  return (
    <Container>
      {!hideTitle && <RegularText style={{ marginBottom: metrics.medium }} fontWeight="bold" textLang="amenities" />}
      <Row>
        {amenities.map((amenity, index) => {
          return <NewAmenetyItem key={index.toString()} icon={amenity.icon} />;
        })}
        {/* <NewAmenetyItem icon="icon-new-wifi" />
        <NewAmenetyItem icon="icon-new-water" />
        <NewAmenetyItem icon="icon-new-coffee" />
        <NewAmenetyItem icon="icon-new-plug" />
        <NewAmenetyItem icon="icon-new-bed" /> */}
      </Row>
    </Container>
  );
};

// export const Amenities = ({ amenities, hideTitle = false }: { amenities: AmenityProps[]; hideTitle?: boolean }) => {
//   return (
//     <Container>
//       {!hideTitle && <RegularText fontWeight="bold" textLang="amenities" />}
//       <Row marginTop={hideTitle ? 0 : metrics.medium} flex style={{ overflow: 'scroll' }}>
//         {amenities.map((amenity, index) => (
//           <Container marginRight={metrics.medium} key={index.toString()} align="center">
//             <Image
//               resizeMode="contain"
//               source={{ uri: amenity.icon }}
//               style={{ width: pixelScaler(16), height: pixelScaler(16) }}
//             />
//             {!hideTitle && (
//               <RegularText color={AppColors.gray} fontSize="medium">
//                 {amenity.label}
//               </RegularText>
//             )}
//           </Container>
//         ))}
//       </Row>
//     </Container>
//   );
// };

// interface Props {
//   text: string;
//   hideTitle?: boolean;
// }

// const AmenetyItem = ({ icon, text, hideTitle = false }: Props) => {
//   return (
//     <Container marginRight={metrics.large} align="center">
//       <Icon color={AppColors.gray} size={pixelScaler(16)} name={icon} />
//       {!hideTitle && <RegularText color={AppColors.gray} fontSize="medium" textLang={text} />}
//     </Container>
//   );
// };

const NewAmenetyItem = ({ icon }: any) => {
  return (
    <Container
      style={{ borderWidth: 1, borderColor: AppColors.ratingBorder, backgroundColor: AppColors.ratingBackground }}
      marginRight={metrics.medium}
      borderRadius={8}
      height={pixelScaler(30)}
      width={pixelScaler(30)}
      align="center">
      {/* <Icon color={AppColors.primary} size={pixelScaler(12)} name={icon} /> */}
      <Image resizeMode="contain" source={{ uri: icon }} style={{ height: pixelScaler(16), width: pixelScaler(16) }} />
    </Container>
  );
};
